import { useContext } from 'react';
import { ThemeStoreContext } from './theme-store-context';

export const useThemeStore = () => {
    const themeStoreContext = useContext(ThemeStoreContext);

    if (!themeStoreContext || !themeStoreContext?.themeStore)
        throw new Error("Couldn't find themeStore");

    return themeStoreContext.themeStore;
};
